import { get } from '@fable/api'
import { Loader } from '@fable/components'
import { useQuery } from 'react-query'
import { HomeClubsRow } from './HomeClubsRow'

export const HomePopularClubsList = () => {
  const { data, isLoading } = useQuery(['popular_club'], () =>
    get('/popular_clubs')
  )

  const popularClubs = data?.data || []

  if (isLoading) return <Loader />
  if (popularClubs.length < 5) return null

  return (
    <HomeClubsRow
      title="Book Clubs Starting Books Soon"
      items={popularClubs}
      type="popular-clubs-starting-soon"
    />
  )
}
